import { HttpTransportType, HubConnection, HubConnectionBuilder } from "@microsoft/signalr";

const { protocol, host } = location;
const homeUrl = `${protocol}//${host}`;

class SignalRConnection {
    url: string;
    connection: HubConnection;
    connectionParams?: number | string;
    joinActionName: string;
    leaveActionName: string;

    constructor(params: {
        url: string;
        connectionParams?: number | string;
        actions: { name: string; action: (data: any) => void }[];
        joinActionName: string;
        leaveActionName: string;
    }) {
        const { url, connectionParams, actions, joinActionName, leaveActionName } = params;
        this.url = `${homeUrl}${url}`;
        this.connectionParams = connectionParams;
        this.joinActionName = joinActionName;
        this.leaveActionName = leaveActionName;

        const options = {
            accessTokenFactory: () => localStorage.getItem("token") ?? "",
            skipNegotiation: true,
            transport: HttpTransportType.WebSockets,
        };
        this.connection = new HubConnectionBuilder()
            .withUrl(this.url, options)
            .withAutomaticReconnect([0, 2000, 10000, 30000, 60 * 1000, 2 * 60 * 1000, 5 * 60 * 1000, 10 * 60 * 1000]) // 0 sec, 2 sec, 10 sec, 1 min, 2 min, 5 min, 10 min
            .build();
        this.connection.onreconnected(() =>
            this.connectionParams
                ? this.connection.invoke(this.joinActionName, this.connectionParams)
                : this.connection.invoke(this.joinActionName),
        );
        actions.forEach((item) => {
            this.connection.on(item.name, item.action);
        });

        this.connect();
        window.addEventListener("beforeunload", this.disconnect);
    }

    connect = () => {
        try {
            this.connection
                .start()
                .then(() =>
                    this.connectionParams
                        ? this.connection.invoke(this.joinActionName, this.connectionParams)
                        : this.connection.invoke(this.joinActionName),
                )
                .catch((err) => console.error("WS connection error", err));
        } catch (err) {
            console.error(err);
        }
    };

    disconnect = () => {
        window.removeEventListener("beforeunload", this.disconnect);

        if (this.connection.state === "Connected") {
            try {
                const leaveRequest = this.connectionParams
                    ? this.connection.invoke(this.leaveActionName, this.connectionParams)
                    : this.connection.invoke(this.leaveActionName);

                leaveRequest
                    .catch((err) => console.error("WS disconnection error", err))
                    .finally(() => this.connection.stop().catch((err) => console.error("WS stop error", err)));
            } catch (err) {
                console.error("WS disconnection error", err);
                this.connection.stop().catch((stopErr) => console.error("WS stop error", stopErr));
            }
        } else {
            this.connection.stop().catch((err) => console.error("WS stop error", err));
        }
    };
}

export default SignalRConnection;
